import React, { useEffect, useState, forwardRef, Fragment } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAllUsers, getWoLoading, CreateUser, GetUserDetailsById, GetUserByEmail, GetUsersBySharedCompanies } from '../redux/store'
import { Input, Form, Label, Row, Col, Button, TabContent, TabPane, ModalBody, ModalFooter, ModalHeader, FormFeedback, Spinner } from 'reactstrap'
import ComponentSpinner from '../../components/spinner/Loading-spinner'
import DefaultSettings from '../../settings/pageSettings'
import { isObjEmpty } from '../../utility/Utils'
import '@styles/react/libs/tables/react-dataTable-component.scss'
import ReactPaginate from 'react-paginate'
import { ChevronDown, ChevronUp, X, RefreshCcw, Plus, Check, Filter } from 'react-feather'
import DataTable from 'react-data-table-component'
import { useNavigate } from 'react-router-dom'
import { userlistColumns } from "./Data"
import classnames from 'classnames'
import Select, { components } from 'react-select'
import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'
import { useForm, Controller } from 'react-hook-form'
import Sidebar from '../Components/SideBar'
import { DefaultConfig } from '../../settings/config'
import CustomValueContainer from "../Components/Select"
import ToastMessage from '../../components/toast-messages'
import toast from 'react-hot-toast'
import { isUserLoggedIn } from "../../@core/auth/utils"

const UsersList = () => {

    const dispatch = useDispatch()
    const [currentPage, setCurrentPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(DefaultSettings.perPage)

    const stores = useSelector((state) => state.commonreducerSlice)
    // const isEmployee = isUserLoggedIn() && JSON.parse(isUserLoggedIn()).isEmployee

    const [firstName, setFirstName] = useState("")
    const [lastName, setLastName] = useState("")
    const [email, setEmail] = useState("")

    const [newFirstName, setNewFirstName] = useState("")
    const [newLastName, setNewLastName] = useState("")
    const [newEmail, setNewEmail] = useState("")
    const [spinnerStatus, setSpinnerStatus] = useState(false)
    const [woData, setWoData] = useState([])
    const [sortName, setSortName] = useState("Id")
    const [sortOrder, setSortOrder] = useState("asc")
    const [displaytableData, setDisplaytableData] = useState(false)
    const selectStyles = DefaultConfig().selectStyles
    const userWriterRole = DefaultConfig().UserWriterRole

    // const [stopMultiLoops, setStopMultiLoops] = useState(false)
    const [firstEnterKey, setFirstEnterKey] = useState([])
    const [lastEnterKey, setLastEnterKey] = useState([])
    const [emailEnterkey, setEmailEnterKey] = useState([])
    const [show, setShow] = useState(false)
    const [disabling, setDisabling] = useState(false)
    const [disableSpinner, setDisableSpinner] = useState(false)
    const loggedinUserDetails = isUserLoggedIn() && JSON.parse(isUserLoggedIn())
    const [displayFitler, setDisplayFilter] = useState(true)

    const options = [
        { value: 'All', label: 'All', id: 3 },
        { value: 'Active', label: 'Active', id: 1 },
        { value: 'InActive', label: 'InActive', id: 2 }
    ]

    const [statusOption, setStatusOption] = useState(options[0])
    const [status, setStatus] = useState(3)

    const ValidSchema = yup.object().shape({
        [`newFirstName`]: yup.string().nullable().required("First Name is a required field"),

        [`newLastName`]: yup.string().nullable().required("Last Name is a required field"),
        [`newEmail`]: yup.string().trim().nullable().required("Email is a required field").email("Email is invalid")
    })

    const { trigger, handleSubmit, control, reset, setValue, formState: { errors } } = useForm({ mode: 'onChange', resolver: yupResolver(ValidSchema) })

    const handleReset = () => {
        reset({
            newFirstName: null,
            newLastName: null,
            newEmail: null
        })
        setNewEmail("")
        setValue("newEmail", "")
        setNewFirstName("")
        setValue("newFirstName", "")
        setValue("newLastName", "")
        setNewLastName("")
        setDisabling(false)
    }

    const toggleSidebar = () => {
        handleReset()
        setShow(!show)
    }

    const navigate = useNavigate()

    function loadingData(responseData) {
        const woDataObj = []
        if (stores.spinner3 && responseData.length > 0) {

            for (let i = 0; i < responseData.length; i++) {
                const element = { ...responseData[i] }
                woDataObj[i] = element
            }
        }
        setWoData(woDataObj)
        setDisplaytableData(false)
        setTimeout(() => {
            sessionStorage.removeItem('pageTransition')
        }, 1000)
    }

    const handleFilterData = (firstName, lastName, email, sortName, sortOrder, status) => {
        dispatch(getWoLoading(false))
        setDisplaytableData(true)
        setCurrentPage(0)
        const obj = {}
        if (true) {
            obj.firstName = firstName
            obj.lastName = lastName
            obj.email = email
        }
        obj.pageIndex = 1
        obj.pageSize = rowsPerPage
        obj.sortName = sortName
        obj.sortOrder = sortOrder
        if (status !== 3) {
            obj.status = status
        }
        let responseData
        async function fetchData(data) {
            if (true) {
                if (loggedinUserDetails?.userRoles[0]?.roleId === 1) {
                    responseData = await dispatch(getAllUsers(data))
                } else {
                    obj.isEmployee = loggedinUserDetails.isEmployee
                    obj.userId = loggedinUserDetails.userRoles[0].userId

                    responseData = await dispatch(GetUsersBySharedCompanies(data))
                }

                if (responseData.payload) {
                    loadingData(responseData.payload.data)
                } else {
                    setDisplaytableData(false)
                }
            }
        }
        fetchData(obj)
    }

    const onSubmit = async (values) => {
        trigger()
        if (isObjEmpty(errors)) {
            setSpinnerStatus(true)
            const obj = {}
            obj["firstName"] = newFirstName
            obj["lastName"] = newLastName
            obj["email"] = newEmail
            obj["status"] = 1
            obj["createdBy"] = 1
            obj["modifiedBy"] = 1
            const response = await dispatch(CreateUser(obj)).finally(() => {
                setSpinnerStatus(false)
                setShow(!show)
                handleReset()
            })
            if (response.payload) {
                handleFilterData("", "", "", "Id", "desc", 3)
            }
        }
    }

    const customStyles = {
        rows: {
            style: {
                backgroundColor: '#f9f9f9'
            }
        }
    }

    const handleCheckboxChange = () => {
        setStatus(status ? 0 : 1)
        handleFilterData(firstName, lastName, email, sortName, sortOrder, status ? 0 : 1)
    }

    const clearFiltersSearch = () => {
        setFirstName("")
        setLastName("")
        setEmail("")
        setStatusOption(options[0])
        setStatus(3)
        handleFilterData("", "", "", sortName, sortOrder, 3)
    }

    function DisplayCondition() {
        return (email || firstName || lastName || status !== 3)
    }
    
    // useEffect(() => {
    //     const result = DisplayCondition()
    //     setDisplayFilter(result)
    // }, [])

    
    const HoverCard = ({ children, content, placement = 'top', testing }) => {
        const [isVisible, setIsVisible] = useState(false)

        const showTooltip = () => setIsVisible(true)
        const hideTooltip = () => setIsVisible(false)

        return (
            <div
                className="hover-card-wrapper"
                style={{ position: 'relative', display: 'inline-block', pointerEvents: !displaytableData ? "unset" : "none", cursor: !displaytableData ? "pointer" : "not-allowed" }}
                disabled={displaytableData}
                onClick={() => {
                    if (testing) {
                        if (displayFitler && DisplayCondition()) {
                            clearFiltersSearch()
                        } else {
                            setDisplayFilter(!displayFitler)
                        }
                    }
                }}
                onMouseEnter={showTooltip}
                onMouseLeave={hideTooltip}

            >
                {children}
                {isVisible && (
                    <div
                        className={`hover-card hover-card-${placement}`}
                        onMouseEnter={showTooltip}
                        onMouseLeave={hideTooltip}
                        style={{
                            position: 'absolute',
                            zIndex: 1000,
                            // backgroundColor: '#fff',
                            // border: '1px solid #ccc',
                            padding: '8px',
                            borderRadius: '4px',
                            boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
                            top: placement === 'top' ? '-40px' : '40px'
                        }}
                    >
                        {content}
                    </div>
                )}
            </div>
        )
    }

    useEffect(() => {
        handleFilterData(firstName, lastName, email, sortName, sortOrder, status)
    }, [rowsPerPage, sortOrder])

    const handlePagination = async (page) => {
        setDisplaytableData(true)
        setCurrentPage(page.selected)
        dispatch(getWoLoading(false))
        const obj = {}
        if (true) {
            obj.firstName = firstName
            obj.lastName = lastName
            obj.email = email
        }
        obj.pageIndex = (page.selected + 1)
        obj.pageSize = rowsPerPage
        obj.sortName = sortName
        obj.sortOrder = sortOrder
        if (status !== 3) {
            obj.status = status
        }
        let responseData
        if (loggedinUserDetails?.userRoles[0]?.roleId === 1) {
            responseData = await dispatch(getAllUsers(obj))
        } else {
            obj.isEmployee = loggedinUserDetails.isEmployee
            obj.userId = loggedinUserDetails.userRoles[0].userId

            responseData = await dispatch(GetUsersBySharedCompanies(obj))
        }
        if (responseData.payload) {
            loadingData(responseData.payload.data)
        } else {
            setDisplaytableData(false)
        }
    }

    // useEffect(() => {
    //     if (stores.spinner3) {
    //         const debounceHandleSelectedRowsChange = setTimeout(() => {
    //             setStopMultiLoops(true)
    //         }, 100)// Adjust the delay as needed
    //         return () => clearTimeout(debounceHandleSelectedRowsChange)
    //     } else {
    //         setStopMultiLoops(false)
    //     }
    // }, [stores.spinner3])

    const handlePerPage = (e) => {
        const value = parseInt(e.currentTarget.value)
        setRowsPerPage(value)
        setCurrentPage(0)
    }

    const CustomPagination = () => (
        <Row className="my-0 mx-0 workorder_pagination_row all_pagination_row">
            <Col sm="12" md="4" lg="3" xl="4" className="d-flex align-items-center p-0 showingEntries ">
                <Label className='mb-0 font-weight-bold showing_panel'>
                    Showing {(((currentPage) * stores.gridSize) + 1)} to {(Math.ceil(stores.recCount / (stores.gridSize)) || 1) !== (currentPage + 1) ? ((((currentPage) * stores.gridSize) + 1) + (stores.gridSize - 1)) : stores.recCount} of {stores.recCount} entries
                </Label>
            </Col>
            <Col sm="12" md="8" lg="9" xl="8"
                className="d-flex align-items-sm-center justify-content-lg-end justify-content-md-end justify-content-start flex-lg-nowrap flex-wrap flex-sm-row flex-column p-0 contentAligment"
            >
                <div className="d-flex align-items-center me-1" style={{ marginTop: "7px" }}>
                    <Label for="rows-per-page font-weight-bold  " className={"form-label1"}>Rows per page: </Label>
                    <Input
                        className="form-control mx-50 "
                        type="select"
                        id="rows-per-page"
                        value={rowsPerPage}
                        onChange={handlePerPage}
                        style={{
                            width: "5rem",
                            padding: "0 0.8rem",
                            backgroundPosition: "calc(100% - 3px) 4px, calc(100% - 20px) 13px, 100% 0"
                        }}
                    >
                        {DefaultSettings?.pagination.map((count, index) => {
                            return (
                                <option value={count.value} key={index.toString()}>
                                    {count.label}
                                </option>
                            )
                        })}
                    </Input>
                </div>
                <ReactPaginate
                    previousLabel={''}
                    nextLabel={''}
                    forcePage={currentPage}
                    onPageChange={page => handlePagination(page)}
                    pageCount={Math.ceil(stores.recCount / (stores.gridSize)) || 1}
                    breakLabel={'...'}
                    pageRangeDisplayed={5}
                    marginPagesDisplayed={5}
                    activeClassName='active'
                    pageClassName='page-item'
                    breakClassName='page-item'
                    nextLinkClassName='page-link'
                    pageLinkClassName='page-link'
                    breakLinkClassName='page-link'
                    previousLinkClassName='page-link'
                    nextClassName='page-item next-item'
                    previousClassName='page-item prev-item'
                    containerClassName={'pagination react-paginate separated-pagination pagination-sm justify-content-end workorder_pagination_view'}
                />
            </Col>
        </Row>
    )

    const BootstrapCheckbox = forwardRef(({ ...props }, ref) => (
        <div className='form-check' style={{ left: (props.name === 'select-all-rows' && '20px'), position: 'absolute' }}>
            <Input type='checkbox' ref={ref} {...props} />
        </div>
    ))

    const handleFirstNameKeyDown = (event) => {
        if (event.key === 'Enter') {
            setFirstEnterKey('Enter')
            if (firstName?.length > 0) {
                handleFilterData(firstName, lastName, email, sortName, sortOrder, status)
            }
        }
    }

    const handleFirstNameBlur = () => {
        if (firstName.length > 0 && firstEnterKey !== 'Enter') {
            handleFilterData(firstName, lastName, email, sortName, sortOrder, status)
        }
    }

    const handleLastNameBlur = () => {
        if (lastName?.length > 0 && lastEnterKey !== 'Enter') {
            handleFilterData(firstName, lastName, email, sortName, sortOrder, status)
        }
    }

    const handleLastNameKeyDown = (event) => {
        if (event.key === 'Enter') {
            setLastEnterKey('Enter')
            if (lastName?.length > 0) {
                handleFilterData(firstName, lastName, email, sortName, sortOrder, status)
            }
        }
    }

    const handleEmailBlur = () => {
        if (email.length > 0 && emailEnterkey !== 'Enter') {
            handleFilterData(firstName, lastName, email, sortName, sortOrder, status)
        }
    }

    const handleEmailKeyDown = (event) => {
        if (event.key === 'Enter') {
            setEmailEnterKey('Enter')
            if (email?.length > 0) {
                handleFilterData(firstName, lastName, email, sortName, sortOrder, status)
            }
        }
    }

    const handleSort = (column) => {
        setSortName(column.sortName)
        const sortingorder = sortOrder
        if (sortingorder === '') {
            setSortOrder('asc')
        } else if (sortingorder === 'asc') {
            setSortOrder('desc')
        } else if (sortingorder === 'desc') {
            setSortOrder('asc')
        }
    }

    const handleRowClick = (row) => {
        navigate(`/user/${row.id}`)
    }

    async function fetchCall() {
        if (!errors.newEmail && newEmail) {
            setDisableSpinner(true)
            try {
                const response = await dispatch(GetUserByEmail({ email: newEmail }))
                if (response?.payload) {
                    setDisableSpinner(false)
                    setDisabling(true)
                    setValue("newFirstName", response?.payload?.data.firstName)
                    setNewFirstName(response?.payload?.data.firstName)
                    setValue("newLastName", response?.payload?.data.lastName)
                    setNewLastName(response?.payload?.data.lastName)
                    toast(t => (<ToastMessage t={t} message={"Data Found"} status={"success"} />))
                } else {
                    setDisableSpinner(false)
                    setDisabling(true)
                    setValue("newFirstName", "")
                    setNewFirstName("")
                    setValue("newLastName", "")
                    setNewLastName("")
                    delete errors.newFirstName
                    delete errors.newLastName
                    toast(t => (<ToastMessage t={t} message={"Data not Found"} status={"success"} />))
                }

            } catch (error) {
                console.error('API call failed:', error)
            }
        }
    }

    return (
        <>
            <Sidebar
                size="sm"
                open={show}
                title={`Add User Details`}
                headerClassName="mb-1"
                contentClassName="pt-0"
                toggleSidebar={toggleSidebar}

            >
                {(show) ? (
                    <Form onSubmit={handleSubmit(onSubmit)}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter') {
                                e.preventDefault()
                            }
                        }}
                        style={{ margin: '0 0' }}>
                        <ModalBody style={{ paddingLeft: '10px', paddingRight: '10px', paddingTop: '20px' }}>
                            <Row>
                                <Col sm='12' md='12' lg='12' xl='12'>
                                    <div className='mt-2 input-wrapper'>
                                        <Controller
                                            defaultValue=''
                                            control={control}
                                            id='newEmail'
                                            name='newEmail'
                                            render={({ field: { onChange, onBlur } }) => <Input
                                                placeholder=''
                                                invalid={errors.newEmail && true}
                                                value={newEmail}
                                                onChange={(val) => {
                                                    setDisableSpinner(true)
                                                    if (val.target.value) {
                                                        delete errors.newFirstName
                                                        delete errors.newLastName

                                                    }
                                                    if (val.target.value === "") {
                                                        setValue("newFirstName", "")
                                                        setValue("newLastName", "")
                                                        setNewLastName("")
                                                        setNewFirstName("")
                                                        setDisabling(false)
                                                    }
                                                    onChange(val, setNewEmail(val.target.value))
                                                }}
                                                onBlur={async () => {
                                                    onBlur()
                                                    setTimeout(() => {
                                                        fetchCall()
                                                    }, 100)
                                                }}
                                                onKeyDown={(event) => {
                                                    if (event.key === "enter") {
                                                        setTimeout(() => {
                                                            fetchCall()
                                                        }, 100)
                                                    }
                                                }}
                                            />}
                                        />
                                        <Label className='form-label' for={`newEmail`}>
                                            Email
                                        </Label>
                                        {errors.newEmail && <FormFeedback>{errors.newEmail.message}</FormFeedback>}
                                    </div>
                                </Col>
                            </Row>
                            {!disableSpinner ? <>
                                {disabling ? <>
                                    <Row>
                                        <Col sm='12' md='12' lg='12' xl='12'>
                                            <div className='mt-2 input-wrapper'>
                                                <Controller
                                                    defaultValue=''
                                                    control={control}
                                                    id='newFirstName'
                                                    name='newFirstName'
                                                    render={({ field: { onChange } }) => <Input
                                                        placeholder=''
                                                        invalid={errors.newFirstName && true}
                                                        value={newFirstName}
                                                        disabled={!disabling}
                                                        onChange={(val) => {
                                                            onChange(val, setNewFirstName(val.target.value))
                                                        }}
                                                    />}
                                                />
                                                <Label className='form-label' for={`newFirstName`}>
                                                    First Name
                                                </Label>
                                                {errors.newFirstName && <FormFeedback>{errors.newFirstName.message}</FormFeedback>}
                                            </div>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col sm='12' md='12' lg='12' xl='12'>
                                            <div className='mt-2 input-wrapper'>
                                                <Controller
                                                    defaultValue=''
                                                    control={control}
                                                    id='newLastName'
                                                    name='newLastName'
                                                    render={({ field: { onChange } }) => <Input
                                                        placeholder=''
                                                        invalid={errors.newLastName && true}
                                                        value={newLastName}
                                                        disabled={!disabling}
                                                        onChange={(val) => {
                                                            onChange(val, setNewLastName(val.target.value))
                                                        }}

                                                    />}
                                                />
                                                <Label className='form-label' for={`newLastName`}>
                                                    Last Name
                                                </Label>
                                                {errors.newLastName && <FormFeedback>{errors.newLastName.message}</FormFeedback>}
                                            </div>
                                        </Col>
                                    </Row>
                                </> : <></>}
                            </> : <>

                            </>}
                        </ModalBody>
                        <ModalFooter className='p-0 d-block' style={{ border: 0, marginTop: '30px' }}>
                            <Row>
                                <Col sm='12' md='12' lg='12' xl='12' className='p-0 mt-1'>
                                    <div className='model_popup_panel model_popup_submit_btn model_popup_footer_fixed' style={{ justifyContent: 'center', padding: "12px 0px", display: "flex", background: "unset" }}>
                                        {spinnerStatus ? (
                                            <Button.Ripple color='primary' disabled={spinnerStatus} style={{ paddding: "0px 0px" }}>
                                                <Spinner size='sm' />
                                                <span className='mx-50'>Loading...</span>
                                            </Button.Ripple>
                                        ) : (
                                            <Fragment>
                                                <Button className='me-1 reset_button_view' outline color='secondary' style={{ paddding: "0px 0px" }} onClick={() => handleReset()}>
                                                    <RefreshCcw size={14} className='align-middle me-sm-25 me-0' />
                                                    <span className='align-middle d-sm-inline-block mx-50'>Reset</span>
                                                </Button>
                                                <Button className='create_submit_btn' type='submit' style={{ paddding: "0px 0px" }}>
                                                    {/* <Check size={18} className='align-middle me-sm-25 me-0'></Check> */}
                                                    <span className='align-middle d-sm-inline-block mx-50'>{'Add User'}</span>
                                                </Button>
                                            </Fragment>
                                        )}
                                    </div>
                                </Col>-
                            </Row>
                        </ModalFooter>
                    </Form>
                ) : (
                    <ComponentSpinner />
                )}
            </Sidebar>

            <Row className="billing-sec" style={{ margin: "0px", paddingTop: '20px' }}>
                <Row style={{ width: "100%" }}>
                    {displayFitler ? <Col md='6' lg='3' xl='3' className='filter_bill1'>Filter By :</Col> : ""}
                    <Col md={displayFitler ? '6' : "12"} lg={displayFitler ? '9' : "12"} xl={displayFitler ? '9' : "12"} className="d-flex align-items-center justify-content-end" style={{ color: '#707070' }}>
                        {/* Filter controls with hover cards */}
                        <HoverCard
                            content={displayFitler && DisplayCondition() ? "Clear All Filters" : (displayFitler ? "Hide Filters" : "Show Filters")}
                            placement="top"
                            testing="checking"
                        >
                            <span className="action-icon mx-1" >
                                {displayFitler && DisplayCondition() ? (
                                    <>
                                        <div style={{ position: 'relative', display: 'inline-block', color: "#707070" }}>
                                            <Filter size={24} />
                                            <span
                                                style={{
                                                    position: 'absolute',
                                                    top: "-4px",
                                                    right: "24%",
                                                    fontSize: "24px",
                                                    fontWeight: "500"
                                                }}
                                            >/</span>
                                        </div >
                                    </>
                                ) : (
                                    <Filter size={24} className="svg-icon" />
                                )}
                            </span>
                        </HoverCard>
                    </Col>
                </Row>
                {displayFitler &&
                    <Row style={{ marginTop: '10px' }}>
                        <Col md="4" lg="3" xl="3" sm="12" className="mb-1 filter-padding">
                            <div className='input-wrapper'>
                                <Input id='invoiceNum'
                                    type="text"
                                    placeholder=''
                                    value={firstName}
                                    onBlur={handleFirstNameBlur}
                                    onChange={(e) => {
                                        setFirstName(e.target.value)
                                        setFirstEnterKey('')
                                        if (!e.target.value) {
                                            handleFilterData("", lastName, email, sortName, sortOrder, status)
                                        }
                                    }}
                                    onKeyDown={handleFirstNameKeyDown}
                                    autoComplete="off"
                                />
                                <Label className='form-label input_label' for='invoiceNum'>First Name</Label>
                                {firstName &&
                                    <div onClick={() => {
                                        setFirstName('')
                                        setFirstEnterKey('')
                                        handleFilterData('', lastName, email, sortName, sortOrder, status)
                                    }} className='clear-icon'>
                                        <X size={16} strokeWidth={3} />
                                    </div>
                                }
                            </div>
                        </Col>
                        <Col md="4" lg="3" xl="3" sm="12" className="mb-1 filter-padding">
                            <div className='input-wrapper'>
                                <Input id='invoiceNum'
                                    type="text"
                                    placeholder=''
                                    value={lastName}
                                    onBlur={handleLastNameBlur}
                                    onChange={(e) => {
                                        setLastName(e.target.value)
                                        setLastEnterKey('')
                                        if (!e.target.value) {
                                            handleFilterData(firstName, "", email, sortName, sortOrder, status)
                                        }
                                    }}
                                    onKeyDown={handleLastNameKeyDown}
                                    autoComplete="off"
                                />
                                <Label className='form-label input_label' for='invoiceNum'>Last Name</Label>
                                {lastName &&
                                    <div onClick={() => {
                                        setLastName('')
                                        setLastEnterKey('')
                                        handleFilterData(firstName, "", email, sortName, sortOrder, status)
                                    }} className='clear-icon'>
                                        <X size={16} strokeWidth={3} />
                                    </div>
                                }
                            </div>
                        </Col>
                        <Col md="4" lg="3" xl="3" sm="12" className="mb-1 filter-padding">
                            <div className='input-wrapper'>
                                <Input id='invoiceNum'
                                    type="text"
                                    placeholder=''
                                    value={email}
                                    onBlur={handleEmailBlur}
                                    onChange={(e) => {
                                        setEmail(e.target.value)
                                        setEmailEnterKey('')
                                        if (!e.target.value) {
                                            handleFilterData(firstName, lastName, "", sortName, sortOrder, status)
                                        }
                                    }}
                                    onKeyDown={handleEmailKeyDown}
                                    autoComplete="off"
                                />
                                <Label className='form-label input_label' for='invoiceNum'>Email</Label>
                                {email &&
                                    <div onClick={() => {
                                        setEmail('')
                                        setEmailEnterKey('')
                                        handleFilterData(firstName, lastName, "", sortName, sortOrder, status)
                                    }} className='clear-icon'>
                                        <X size={16} strokeWidth={3} />
                                    </div>
                                }
                            </div>
                        </Col>
                        <Col sm="12" md="4" lg="3" xl="3" className="mb-1 filter-padding">
                            <div>
                                <Select
                                    classNamePrefix="select"
                                    options={options}
                                    value={statusOption}
                                    onChange={(val) => {
                                        setStatusOption(val)
                                        if (val?.id) {
                                            setStatus(val?.id)
                                        }
                                        handleFilterData(firstName, lastName, email, sortName, sortOrder, val?.id)
                                    }}
                                    className={classnames('react-select', { 'is-invalid': errors['country'] })}
                                    placeholder={`Select Status`}
                                    styles={selectStyles}
                                    components={{ ValueContainer: CustomValueContainer }}
                                />
                            </div>
                        </Col>
                    </Row>
                }
            
                <div style={{ marginTop : displayFitler ? '0px' : '-32px' }}>
                    <div className='mb-1 filter-padding d-none' style={{ marginTop: "10px" }}>
                        <Input
                            style={{ marginTop: "6px" }}
                            type="checkbox"
                            checked={!status}
                            className="d-none"
                            onChange={handleCheckboxChange}
                        /><span className='mx-1 d-none' style={{ fontSize: "14px", color: "#000" }}>All Users</span>
                        {(email || firstName || lastName || status !== 3) &&
                            <Button color='primary' className='btn-prev' onClick={() => clearFiltersSearch()} style={{ width: '116px' }} >
                                <RefreshCcw size={13} className='' />
                                <span className='align-middle d-sm-inline-block' style={{ margin: "0px 3px" }}>Reset</span>
                            </Button>
                        }
                    </div>
                    {userWriterRole() && (
                        <div className='mb-1 filter-padding'>
                            <div style={{ display: "flex", justifyContent: "start" }}>
                                <Button.Ripple color='primary' onClick={() => setShow(!show)} style={{ maxWidth: "250px", margin: '0px 4px', textAlign: "Right", maxHeight: "40px" }}>
                                    <Plus size={14} className='' style={{ marginTop: '-7px' }} />
                                    <span className='align-middles mx-50'>Invite New User</span>
                                </Button.Ripple>
                            </div>
                        </div>
                    )}
                </div>
                <Col lg='12' md='12'>
                    {(stores.spinner3 && !displaytableData) ? (
                        <TabContent className="custom-tab-content">
                            <div className={woData.length > 0 ? '' : ' rdt_Table_Height'}>
                                <TabPane>
                                    <DataTable
                                        noHeader
                                        pagination
                                        columns={userlistColumns(handleRowClick)}
                                        //  selectableRows={activeTab === 'tab0'}
                                        selectableRowsComponent={BootstrapCheckbox}
                                        paginationPerPage={stores.gridSize}
                                        className='react-dataTable react_main_sub_warpper bill-data-table-container'
                                        sortIcon={sortOrder === 'asc' ? <ChevronUp size={10} /> : <ChevronDown size={10} />}
                                        paginationDefaultPage={currentPage + 1}
                                        paginationComponent={CustomPagination}
                                        data={woData.length ? woData : []}
                                        noDataComponent={woData.length === 0 && 'There are no records to display'}
                                        // onSelectedRowsChange={handleSelectedRowsChange}
                                        // selectableRowSelected={selectableRowSelected}
                                        fixedColumns
                                        customStyles={customStyles}
                                        onSort={handleSort}
                                        conditionalRowStyles={[
                                            {
                                                when: (row, index) => index % 2 === 0,
                                                style: {
                                                    backgroundColor: '#ffffff'
                                                }
                                            },
                                            {
                                                when: (row, index) => index % 2 !== 0,
                                                style: {
                                                    backgroundColor: '#f9f9f9'
                                                }
                                            }
                                        ]}
                                        onRowClicked={handleRowClick}
                                        pointerOnHover
                                        highlightOnHover
                                    // onSort={handleSort}
                                    />
                                </TabPane>
                            </div>
                        </TabContent>
                    ) : (
                        <ComponentSpinner />
                    )}
                </Col>
            </Row>
        </>
    )
}

export default UsersList
